/**
 *
 * A hook to obtain articles from Knowledge Base.
 *
 * - If the `categoryId` is passed in then it will use that to find the category and its list of `articles`.
 * - If not then it will use `CategoryContext` to find a category to use.
 * - If it can't find a category to look up then it will throw an `Error`.
 * - `limit` is an optional amount of articles that will be returned from the hook.
 *
 * @module
 */
import { useCategory } from './useCategory';
import { useSelector } from '../actions/types';
import { categoryTree } from '../selectors';
import { throwIfDevelop } from '../utils';
/**
 *
 * # useArticles
 *
 * Usage example:
 *
 *
 * ```javascript
 * import { useArticles } from "@elevio/kb-kit/lib/hooks";
 *
 * export const MyComponent = ({ children, categoryId }) => {
 *   const { totalCount, articles } = useArticles({ categoryId, limit });
 *   console.log(totalCount); // number | null
 *   console.log(articles); // Array<IArticleFragment>;
 *
 *   return (
 *     ...
 *   );
 * ;
 * ```
 */
export function useArticles({ limit, categoryId, } = {}) {
    const category = useCategory({ categoryId });
    if (!category)
        throwIfDevelop(`not sure what category to use in useArticles\n Params limit: ${limit}, categoryId: ${categoryId}`);
    const articlesInfo = useSelector((state) => {
        if (!category) {
            return {
                articles: [],
                totalCount: 0,
            };
        }
        return categoryTree.articles(state, category.id, { limit });
    });
    return articlesInfo;
}
//# sourceMappingURL=useArticles.js.map